import { Component, useState, useEffect } from "react";
import KithSearchBar from "../KithSearchBar/index";
import KithNavbar from "../Navbar/KithNavbar/index";
import KithInfoSubNavbar from "../Navbar/KithInfoSubNavbar";
import KithFooter from "../KithFooter/index";
import axios from 'axios';
import { Card } from '../About/Leadership/Staff/Staff';
import "./index.css";

export const KithLeadership = () => {
  const [officerData, setOfficerData] = useState([]);

  useEffect(() => {
    axios.get('/api/officers/')
      .then(response => {
        setOfficerData(response.data);
      })
      .catch(error => {
        console.error('Error fetching officers data:', error);
      });
  }, []);

  console.log(officerData);

  return (
    <>
      <KithNavbar />
      <KithInfoSubNavbar />
      <div className="kith-leadership-container">
        <div className="kith-leadership-upper-section">
          <div>
            <h1>Building the Next Big Thing</h1>
            <p>
            Leadership at Kith is about trusting your team to introduce revolutionary ideas that will boost classroom outcomes.

            </p>
          </div>
          <img src="https://plus.unsplash.com/premium_photo-1683121935695-ff8598e7f0ab?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" />
        </div>
        <div className="mobile-kith-leadership-upper-section">
          <h1>Building the Next Big Thing</h1>
          <p>
          Leadership at Kith is about trusting your team to introduce revolutionary ideas that will boost classroom outcomes.

          </p>
        </div>
        
        <div className="kith-leadership-images-container">
          <h1 className="kith-font48">Officers</h1>
          <KithSearchBar />
          <div className="card-list">
            {officerData.map((item, index) => (
              <Card key={index} item={item} />
            ))}
          </div>
        </div>
      </div>
      <KithFooter />
    </>
  );
}

export default KithLeadership;
